export enum Filters {
	OneMonthPriorReminder = "fields/RenewalDate le '{{dateTime}}' and fields/IsOneMonthPriorReminderSent eq 0",
    OneWeekPriorReminder = "fields/RenewalDate le '{{dateTime}}' and fields/IsOneWeekPriorReminderSent eq 0",
    OverdueReminder = "fields/RenewalDate lt '{{dateTime}}' and fields/IsOverdueReminderSent eq 0",
    NonResponsiveReminder = "fields/SentTime lt '{{dateTime}}' and fields/IsNonResponsiveReminderSent eq 0 and fields/Status eq 'Sent to Doctor'",
}